import { useEffect, useState } from "react";
import api from "../services/api";
import { Sortable } from "sortablejs";
import { toast, ToastContainer } from "react-toastify";
export default function ProductModal({ show, onClose, onSuccess, product }) {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [variants, setVariants] = useState([]);
  const [form, setForm] = useState({ nama_produk: "", kategoriId: "", description: "" });
  const [images, setImages] = useState([]); // URL lama atau preview baru
  const [previewFiles, setPreviewFiles] = useState([]); // File baru
  const [video, setVideo] = useState(null);
  const [previewVideo, setPreviewVideo] = useState(null);

  useEffect(() => { fetchCategories(); }, []);

  useEffect(() => {
    if (show) {
      setVariants(product?.variants || []);
      setForm({
        nama_produk: product?.nama_produk || "",
        kategoriId: product?.kategoriId || "",
        description: product?.description || "",
      });

      // Parse images aman
      let imgs = [];
      if (product?.images) {
        if (Array.isArray(product.images)) imgs = product.images;
        else {
          try { imgs = JSON.parse(product.images); } catch { imgs = []; }
        }
      }
      setImages(imgs.map(i => i.startsWith("http") ? i : `/uploads/${i}`));
      setVideo(product?.video ? (product.video.startsWith("http") ? product.video : `/uploads/${product.video}`) : null);
      setPreviewFiles([]);
      setPreviewVideo(null);
    } else {
      setVariants([]);
      setForm({ nama_produk: "", kategoriId: "", description: "" });
      setImages([]);
      setPreviewFiles([]);
      setVideo(null);
      setPreviewVideo(null);
    }
  }, [show, product]);

  useEffect(() => { if (show) initSortable(); }, [images, show]);

  const fetchCategories = async () => {
    try {
      const res = await api.get("/categories");
      setCategories(res.data);
    } catch (err) { console.error(err); }
  };

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const addVariant = () => setVariants([...variants, { nama_varian: "", harga: "", stok: "", berat_gram: "" }]);
  const removeVariant = i => setVariants(variants.filter((_, idx) => idx !== i));
  const updateVariant = (i, e) => {
    const copy = [...variants]; copy[i][e.target.name] = e.target.value; setVariants(copy);
  };

  const handleAddCategory = async () => {
    if (!newCategory.trim()) return;
    try {
      const slug = newCategory.toLowerCase().replace(/\s+/g, "-");
      await api.post("/categories", { name: newCategory, slug });
      setNewCategory("");
      fetchCategories();
      toast.success("Kategori berhasil ditambahkan", { autoClose: 2500, progress: undefined });
    } catch (err) {
      toast.error("Gagal menambahkan kategori: " + err.message, { autoClose: 3000 });
    }
  };

  const handleImagesChange = e => {
    const files = Array.from(e.target.files);
    setPreviewFiles(prev => [...prev, ...files]);
    setImages(prev => [...prev, ...files.map(f => URL.createObjectURL(f))]);
  };

  const handleVideoChange = e => {
    const file = e.target.files[0];
    setPreviewVideo(URL.createObjectURL(file));
    setVideo(file);
  };

  const removeImage = i => {
    const numOldImages = images.length - previewFiles.length;
    if (i >= numOldImages) {
      const copyPrev = [...previewFiles]; copyPrev.splice(i - numOldImages, 1); setPreviewFiles(copyPrev);
    }
    const copyImages = [...images]; copyImages.splice(i, 1); setImages(copyImages);
  };

  const initSortable = () => {
    const el = document.getElementById("sortable-images");
    if (!el) return;
    Sortable.create(el, {
      animation: 150,
      onEnd: e => {
        const copy = [...images]; const [moved] = copy.splice(e.oldIndex, 1); copy.splice(e.newIndex, 0, moved); setImages(copy);
        if (previewFiles.length > 0) {
          const copyPrev = [...previewFiles]; const [movedPrev] = copyPrev.splice(e.oldIndex, 1); copyPrev.splice(e.newIndex, 0, movedPrev); setPreviewFiles(copyPrev);
        }
      },
    });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const fd = new FormData();
    Object.keys(form).forEach(k => fd.append(k, form[k]));
    fd.append("variants", JSON.stringify(variants));

    // Kirim hanya file baru
    previewFiles.forEach(f => fd.append("images", f));

    // Video
    if (video instanceof File) fd.append("video", video);

    // PUT untuk edit
    if (product) await api.put(`/products/${product.id}`, fd);
    else await api.post("/products", fd);

    toast.success(product ? "Produk berhasil diperbarui" : "Produk berhasil ditambahkan");
    onSuccess();
    onClose();
  } catch (err) {
    console.error(err);
    toast.error("Gagal menyimpan produk: " + err.message);
  }
};
  if (!show) return null;

  return (
    <>
      <div className="modal d-block bg-dark bg-opacity-50">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">{product ? "✏️ Edit Produk" : "➕ Tambah Produk"}</h5>
                <button type="button" className="btn-close" onClick={onClose} />
              </div>
              <div className="modal-body">
                <input className="form-control mb-2" placeholder="Nama Produk" name="nama_produk" value={form.nama_produk} onChange={handleChange} required />
                <div className="d-flex mb-2 gap-2">
                  <select className="form-select" name="kategoriId" value={form.kategoriId} onChange={handleChange} required>
                    <option value="">Pilih Kategori</option>
                    {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                  <input className="form-control" placeholder="Kategori baru" value={newCategory} onChange={e => setNewCategory(e.target.value)} />
                  <button type="button" className="btn btn-outline-primary" onClick={handleAddCategory}>➕</button>
                </div>
                <textarea className="form-control mb-2" rows="3" placeholder="Deskripsi" name="description" value={form.description} onChange={handleChange} />
                <label className="fw-bold mt-2">Variants</label>
                {variants.map((v, i) => (
                  <div key={i} className="row g-2 mb-2 align-items-center">
                    <div className="col"><input className="form-control" name="nama_varian" placeholder="Nama Varian" value={v.nama_varian} onChange={e => updateVariant(i, e)} required /></div>
                    <div className="col"><input className="form-control" type="number" name="harga" placeholder="Harga" value={v.harga} onChange={e => updateVariant(i, e)} required /></div>
                    <div className="col"><input className="form-control" type="number" name="stok" placeholder="Stok" value={v.stok} onChange={e => updateVariant(i, e)} required /></div>
                    <div className="col"><input className="form-control" type="number" name="berat_gram" placeholder="Gram" value={v.berat_gram} onChange={e => updateVariant(i, e)} /></div>
                    <div className="col-auto"><button type="button" className="btn btn-danger btn-sm" onClick={() => removeVariant(i)}>🗑️</button></div>
                  </div>
                ))}
                <button type="button" className="btn btn-sm btn-outline-primary mb-3" onClick={addVariant}>➕ Tambah Varian</button>
                <div className="mb-2">
                  <label className="form-label fw-bold">Upload Gambar Produk</label>
                  <input type="file" className="form-control" multiple onChange={handleImagesChange} />
                </div>
                {images.length > 0 && (
                  <div id="sortable-images" className="d-flex flex-wrap gap-2 mb-2">
                    {images.map((img, i) => (
                      <div key={i} className="position-relative border p-1" style={{ width: 80, height: 80, borderRadius: 6 }}>
                        <img src={img} alt="preview" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 4 }} />
                        <button type="button" className="position-absolute top-0 end-0 btn btn-sm btn-danger" style={{ padding: "2px 4px" }} onClick={() => removeImage(i)}>🗑️</button>
                      </div>
                    ))}
                  </div>
                )}
                <div className="mb-2">
                  <label className="form-label fw-bold">Upload Video Produk</label>
                  <input type="file" className="form-control" onChange={handleVideoChange} />
                </div>
                {video && (
                  <video width="250" controls className="mb-2">
                    <source src={previewVideo || video} type="video/mp4" />
                  </video>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={onClose}>Batal</button>
                <button type="submit" className="btn btn-primary">Simpan</button>
              </div>
          </form>
        </div>
      </div>
    </div>
  <ToastContainer />
    </>
  );
}
